"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useTheme_1 = __importDefault(require("./useTheme"));
var boxShadow = '0px 0px 0px 0px white';
function useCardStyles() {
    var _a = (0, useTheme_1.default)(), block = _a.block, size = _a.size, borderColor = _a.borderColor, backgroundColor = _a.backgroundColor;
    var border = block.isWhite ? "".concat(size.border.base, "px solid ").concat(borderColor.soft) : 'none';
    return {
        backgroundColor: backgroundColor.base,
        boxShadow: boxShadow,
        borderRadius: size.border.radius.fiveX,
        border: border
    };
}
exports.default = useCardStyles;
//# sourceMappingURL=useCardStyles.js.map